// @flow
import Link from 'next/link'
import { withRouter } from 'next/router'
import * as React from 'react'
import { injectIntl } from 'react-intl'
import { compose } from 'redux'
import type { NavLink as NavLinkType, NavLinkProps } from '../../types/Link'
import { doesRouteMatchWith } from '../routes'

const linkPrefix = process.env.LINK_PREFIX || ''

export function NavLink ({
  activeClassName,
  className,
  intl,
  labelId,
  link,
  isSelectedMatchers = [],
  router
}: NavLinkProps) {
  if (!router || !intl || !link) {
    return null
  }
  const isSelected = doesRouteMatchWith(router, isSelectedMatchers)

  return (
    <Link prefetch href={link.href} as={link.as}>
      <a
        data-qa={labelId}
        className={[className, isSelected ? activeClassName : ''].join(' ')}
      >
        {intl.formatMessage({ id: labelId })}
      </a>
    </Link>
  )
}

export default compose(
  withRouter,
  injectIntl
)(NavLink)
